import React from 'react';
import { FiEye} from "react-icons/all";
import { Link } from "react-router-dom";
import "../../assets/scss/order-list.scss";
import 'bootstrap-daterangepicker/daterangepicker.css';
import ExportCSV from "../common/ExportCSV"

const headers = [
  { label: "Patner Name", key: "name" },
  { label: "Phone", key: "phone" },
  { label: "Orders No", key: "order_count" },
  { label: "Margin", key: "margin_amount" },
];

const List  = ({partner_list, date}) => {

    return (
        <div className="main-content">
                <div className="card-block">
                    <div className="block-body">
                    <div className="page-header">
                    <h2 className="page-title" style={{fontWeight:'bold'}}>Partner List</h2>
                    <div className="ml-auto" style={{display: "flex"}}>
                        <ExportCSV 
                        title = "Partner List"
					              data={partner_list}
                        headers={headers} />
                        </div>
                    </div>
                        <table className="order-table table table-striped">
                        <thead>
                        <tr>
                            <th style={{width: '20px'}}>#</th>
                            <th className='text-center'>Partner Names</th>
                            <th className='text-center'>Phone</th>
                            <th className='text-center'>order count</th>
                            <th className='text-center'>amount</th>
                            <th className='text-center'>Received by Partner</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {partner_list?.length > 0 ? partner_list?.map((item, index) => {
                            return (
                                <tr key={index}>
                                  <td>{ index + 1}</td>
                                  <td>
                                      <div className="order-item text-center">
                                          {item.name}
                                      </div>
                                  </td>
                                  <td>
                                    <div className="order-item text-center">
                                        {item.phone}
                                    </div>
                                  </td>
                                  <td>
                                      <div className="order-item text-center">
                                      {item.order_count}
                                      </div>
                                  </td>
                                  <td>
                                      <div className="order-item text-center">
                                      {item.margin_amount}
                                      </div>
                                  </td>
                               
                                  <td>
                                      <div className="order-item text-center">
                                      {item.margin_received_by_partner?'Paid':'Unpaid'}
                                      </div>
                                  </td>
                                  <td>
                                    <Link 
                                      to={{
                                        pathname:`/partner-commission-details/${item.id}`,
                                        state:{
                                          date:date
                                        }
                                      }} 
                                      className="btn btn-sm btn-default"
                                    >
                                      <FiEye/>
                                    </Link>
                                  </td>
                                </tr>
                            );
                        }) : <tr><td colSpan={7}>No partners found</td></tr>}
                        </tbody>
                        </table>
                    </div>
                </div>
            </div>
    )
  }

export default List
